<template>
  <nav
    class="items-center rounded-full bg-slate-100 p-0.5 ring-1 ring-black/5"
    :class="block ? 'flex w-full' : 'inline-flex'"
    aria-label="Cumpără sau vinde"
  >
    <NuxtLink
      :to="shopPath('/produse')"
      class="rounded-full px-3 py-1.5 text-center text-sm font-semibold transition-colors"
      :class="[
        block ? 'flex-1' : '',
        selling
          ? 'text-slate-600 hover:text-slate-900'
          : 'bg-white text-slate-900 shadow-sm',
      ]"
      :aria-current="selling ? undefined : 'page'"
    >
      Cumpără
    </NuxtLink>
    <NuxtLink
      :to="shopPath('/vinde')"
      class="rounded-full px-3 py-1.5 text-center text-sm font-semibold transition-colors"
      :class="[
        block ? 'flex-1' : '',
        selling
          ? 'bg-brand-600 text-[var(--ui-text-on-primary)] shadow-sm'
          : 'text-slate-600 hover:text-slate-900',
      ]"
      :aria-current="selling ? 'page' : undefined"
    >
      Vinde
    </NuxtLink>
  </nav>
</template>

<script setup lang="ts">
defineProps<{
  block?: boolean
}>()

const route = useRoute()
const shopPath = useShopPath()

const selling = computed(() => {
  const current = route.path.replace(/\/+$/, '') || '/'
  return current.endsWith('/vinde') || current.includes('/vinde/')
})
</script>
